import React from 'react';
import { Button } from 'semantic-ui-react';

class ButtonsAttached extends React.Component {

  returnButton(lab, index) {
    if (lab===this.props.active) {
      return <Button active onClick={this.props.onClick}
                     key={index}
                     value={this.props.values[index]}>{lab}</Button>
    } else {
      return <Button onClick={this.props.onClick} 
                     key={index}
                     value={this.props.values[index]}>{lab}</Button>
    }
  }

  render() {
    const buttons = this.props.labels.map((lab,index) =>
      this.returnButton(lab, index)
    );

    return(
      <Button.Group>
        {buttons}
      </Button.Group>
    );
  }
}

export default ButtonsAttached;